import React, { FC } from 'react';
import { ProgressBar } from 'react-native-paper';
import styles from './styles';
import { purple } from '../../../constants/palette';
import GalanoGrotesqueText from '../GalanoGrotesqueText';
import View from '../View';

export type AudioProgressBarProps = {
  currentPosition: number;
  totalDuration: number;
};

export const AudioProgressBar: FC<AudioProgressBarProps> = (props) => {
  const { currentPosition, totalDuration } = props;
  // Progress bar fill
  const progress = currentPosition / totalDuration;

  // Right most static time duration in 3:45 format
  const totalMinutes = Math.floor(totalDuration / 1000 / 60);
  let totalSeconds: string | number;
  totalSeconds = Math.floor((totalDuration / 1000) % 60);
  if (totalSeconds < 10) {
    totalSeconds = `0${totalSeconds}`;
  }
  const totalTime = `${totalMinutes}:${totalSeconds}`;

  // Left most dynamic incrementing time counter in 0:45 format
  const currentMinutes = Math.floor(currentPosition / 1000 / 60);
  let currentSeconds: string | number;
  currentSeconds = Math.floor((currentPosition / 1000) % 60);
  if (currentSeconds < 10) {
    currentSeconds = `0${currentSeconds}`;
  }

  const countUpTimer = `${currentMinutes}:${currentSeconds}`;

  return (
    <View>
      <ProgressBar
        progress={progress}
        color={purple}
        style={styles.progressStyle}
      />
      <View style={styles.counter}>
        <GalanoGrotesqueText style={styles.counterText}>
          {countUpTimer}
        </GalanoGrotesqueText>
        <GalanoGrotesqueText style={styles.counterText}>
          {totalTime}
        </GalanoGrotesqueText>
      </View>
    </View>
  );
};

export default AudioProgressBar;
